import { useGetCustomerQuery } from "../api/Customers";

import type { UUID } from "../../../utils";

export function useGetCustomerQueryResponse(
  id: UUID,
  options?: { skip: boolean }
) {
  const { data, isLoading, isFetching, isError, refetch } = useGetCustomerQuery(
    { id },
    options
  );

  return {
    customer: data,
    isCustomerLoading: isLoading,
    isCustomerFetching: isFetching,
    isCustomerError: isError,
    refetch,
  };
}
